// extracted by mini-css-extract-plugin
module.exports = {"codeCheckResult":"codeCheckResult_codeCheckResult__9L7F-","failed":"codeCheckResult_failed__2lnd7","text":"codeCheckResult_text__3UP6f","button":"codeCheckResult_button__1p8gs"};